export const signUpAction = (payload) => ({
    type: "SIGN_UP",
    payload
})